module.exports = __webpack_public_path__ + "img/astro5.fa269afd.jpg";